"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function Asteroids() {
    var s = document.createElement('script');
    document.body.appendChild(s);
    s.src = '/js/asteroids.min.js';
}
exports.Asteroids = Asteroids;
